import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { openClose } from '@core/animations/animations';
import { StewartFunctions } from '@functions/stewart.service';
import { take } from 'rxjs/operators';
import { ICON } from '@core/util/icon';
import { environment } from 'src/environments/environment';
import { StewartTokensApiService } from 'src/app/shared/api-repos/stewart-tokens/stewart-tokens.api.service';
import { Select } from '@ngxs/store';
import { BusinessUsersState } from '@state/business-users/business-users.state';
import { BusinessUser } from '@models/businesses';
import { Observable } from 'rxjs';
import { envTypes } from 'src/environments/env.types';
import { Logger } from '@core/logger';

export enum CallbackState {
	acceptProfileId = 'acceptProfileId',
	savingAuth = 'savingAuth',
	savedSuccess = 'savedSuccess',
	loginError = 'loginError',
	authSaveError = 'authSaveError',
}

export const STEWART_CLOSE_PORTAL_POST_MESSAGE = 'close-portal';
export const STEWART_AUTH_SUCCESS_PORTAL_POST_MESSAGE = 'auth-success';
const isDev = environment.env === envTypes.DEVELOPMENT;

@Component({
	selector: 'app-stewart-callback',
	templateUrl: './stewart-callback.component.html',
	styleUrls: ['./stewart-callback.component.scss'],
	animations: [openClose()],
	standalone: false,
})
export class StewartCallbackComponent implements OnInit {
	public ICON = ICON;

	public accessToken: string;
	public refreshToken: string;
	public states = CallbackState;
	public state: CallbackState = CallbackState.acceptProfileId;

	@Select(BusinessUsersState.getLoggedInBusinessUser)
	user$: Observable<BusinessUser>;

	constructor(
		private activatedRoute: ActivatedRoute,
		private stewartFunctions: StewartFunctions,
		private stgTokensService: StewartTokensApiService,
	) {}

	async ngOnInit(): Promise<void> {
		try {
			this.getTokensFromQueryParams();

			if (!this.accessToken && !this.refreshToken) {
				try {
					const tokenResponse =
						await this.stgTokensService.getTokensFromCodeExchange();

					if (tokenResponse) {
						this.state = CallbackState.savedSuccess;
						parent.postMessage(STEWART_AUTH_SUCCESS_PORTAL_POST_MESSAGE, '*');

						isDev && window.close();
					} else if (tokenResponse === false) {
						this.state = CallbackState.loginError;
					}
				} catch (err) {
					this.state = CallbackState.loginError;
					Logger.exception(err);
				}
			}

			if (!this.accessToken) {
				Logger.error('Stewart Titles Auth Redirect - Missing access token');
				this.state = CallbackState.loginError;

				return;
			}

			if (!this.refreshToken) {
				Logger.error('Stewart Titles Auth Redirect - Missing refresh token');
				this.state = CallbackState.loginError;

				return;
			}
		} catch (err) {
			this.state = CallbackState.loginError;
			Logger.exception(err, {
				message: 'Stewart Title Auth Redirect - Error saving auth details',
			});
		}

		try {
			this.state = CallbackState.savingAuth;
			await this.stewartFunctions
				.storeAuth_v2(this.accessToken, this.refreshToken)
				.pipe(take(1))
				.toPromise();
			this.state = CallbackState.savedSuccess;
			parent.postMessage(STEWART_AUTH_SUCCESS_PORTAL_POST_MESSAGE, '*');
		} catch (err) {
			const errMsg = 'Stewart - error when attempting to save users auth';
			Logger.exception(err, { message: errMsg });
			this.state = CallbackState.authSaveError;
			throw err;
		}
	}

	private getTokensFromQueryParams() {
		this.accessToken = this.activatedRoute.snapshot.queryParams['access_token'];
		this.refreshToken =
			this.activatedRoute.snapshot.queryParams['refresh_token'];
	}

	close() {
		parent.postMessage(STEWART_CLOSE_PORTAL_POST_MESSAGE, '*');
	}
}
